module.exports = __webpack_public_path__ + "static/media/tripbuddyapp.680d5511.png";